import React from 'react';
import {
  Modal,
  Button,
  Glyphicon,
} from 'react-bootstrap';
import './util.css';

export default class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = { show: props.show || false };
  }
  componentWillReceiveProps(props) {
    if (props.show !== undefined) {
      this.setState({ show: props.show });
    }
  }
  openModal() {
    this.setState({ show: true });
  }
  closeModal() {
    this.setState({ show: false });
    if (this.props.hideAlert) {
      this.props.hideAlert();
    }
  }

  render() {
    return (<div><Modal
      show={this.state.show}
      onHide={this.closeModal}
    >
      <Modal.Body className="alert-modal-body">
        <span>
          <span className="alert-icon"><Glyphicon glyph="exclamation-sign" /></span>
        </span>
        <span
          id="alertText"
          style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
        >
          {this.props.message}
        </span>
      </Modal.Body>
      <Modal.Footer className="alert-modal-footer">
        <Button
          onClick={this.closeModal}
          style={{ float: 'left' }}
          id="alertOkBtn"
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal></div>
    );
  }
}

Alert.propTypes = {
  message: React.PropTypes.string,
  show: React.PropTypes.bool,
  hideAlert: React.PropTypes.func,
};
